export default __webpack_public_path__ + "static/1574-d9031393614a8abe4e2128fa57bff5d5.gif";